var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 7.286,
    y: 173.1,
    style: {
      fill: "#103B9B"
    },
    width: 497.43,
    height: 165.81
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M395.901,7.286H116.099C56.003,7.286,7.286,56.003,7.286,116.099v56.997h497.427v-56.997 C504.714,56.003,455.997,7.286,395.901,7.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED1F34"
    },
    d: "M7.286,395.901c0,60.095,48.717,108.812,108.812,108.812h279.803 c60.095,0,108.812-48.717,108.812-108.812v-56.997H7.286V395.901z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.901,0H116.099C52.082,0,0,52.082,0,116.099v279.803C0,459.918,52.082,512,116.099,512h279.803 C459.918,512,512,459.918,512,395.901V116.099C512,52.082,459.918,0,395.901,0z M116.099,14.573h279.803 c55.981,0,101.526,45.544,101.526,101.526v49.71H14.573v-49.71C14.573,60.117,60.118,14.573,116.099,14.573z M395.901,497.427 H116.099c-55.981,0-101.526-45.544-101.526-101.526v-49.71h390.655c4.025,0,7.286-3.262,7.286-7.287 c0-4.024-3.262-7.286-7.286-7.286H14.573V180.382h482.854v151.236H438.39c-4.025,0-7.286,3.262-7.286,7.286 c0,4.024,3.262,7.287,7.286,7.287h59.037v49.71C497.427,451.883,451.882,497.427,395.901,497.427z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/ru.1b62c11e5ab253e2a079e40bde16820c.svg";
export { ForwardRef as ReactComponent };